import React, { ChangeEvent, InputHTMLAttributes } from "react";
import { cn } from "../../lib";

interface ICustomTextareaProps
  extends InputHTMLAttributes<HTMLTextAreaElement> {
  leading?: JSX.Element;
  trailing?: JSX.Element;
  className?: string;
  onChange?: (event: ChangeEvent<HTMLTextAreaElement>) => void;
  value?: string;
  rows?: number;
  cols?: number;
  placeholder?: string;
  containerClassName?: string;
  errorMessage?: any;
  label?: string;
}

const ICTextArea: React.FC<ICustomTextareaProps> = ({
  leading,
  trailing,
  className,
  rows = 5,
  cols = 50,
  containerClassName,
  errorMessage,
  label,
  disabled,
  required,
  placeholder,
  ...inputProps
}) => {
  return (
    <div className="floating-text-area">
      <div
        className={cn(`custom-text-area-container`, {
          "error-border": errorMessage,
          [`${containerClassName}`]: containerClassName,
        })}
      >
        <div className="flex w-full">
          <textarea
            className={cn("custom-text-area bg-transparent", {
              "text-disable": disabled,
              "no-placeholder": !placeholder,
              "has-placeholder": !!placeholder,
            })}
            rows={rows}
            disabled={disabled}
            cols={cols}
            {...inputProps}
            placeholder={placeholder ?? "p"}
          />
          {label && (
            <label className="px-1">{label + (required ? "*" : "")}</label>
          )}
        </div>
        {trailing && <div className="px-3">{trailing}</div>}
      </div>
      {errorMessage && (
        <div className="text-sm text-danger">{errorMessage}</div>
      )}
    </div>
  );
};

export default ICTextArea;
